<span matTooltip="{{tooltip}}">
  <mat-icon [attr.alt]="tooltip" class="material-icons {{mdIconClass}}">{{mdIconName}}</mat-icon>
</span>
